/**
 * Audit Log Module Routes
 *
 * Route definitions for the audit log admin view.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/audit-log',
        component: ModuleLayout,
        meta: {
            moduleKey: 'audit_log',
        },
        children: [
            {
                path: '',
                name: 'audit-log-list',
                component: () => import('./views/AuditLogList.vue'),
                meta: {
                    title: 'Audit Log',
                },
            },
        ],
    },
]

export default routes
